import { ExportAssortmentSearchCriteria } from '@shared/models';
import {
  ActionReportEnum,
  AwaitingAllocationForGroupOrderReportCriteria,
  CJXMemberRewardTransactionCriteria,
  CJXSalesTransactionReportCriteria,
  CJXVoucherExportCriteria,
  CashCountingReportCriteria,
  CashSettlementTransactionReportCriteria,
  CheckProductTagCriteria,
  CollectExpiredPromotionTagCriteria,
  CountItemInToteReportCriteria,
  CrossDockInvoiceReportCriteria,
  DcAssortmentExportCriteria,
  DestroyTransactionExportReportCriteria,
  DispatchToteReportCriteria,
  GiftWithPurchaseReportCriteria,
  GiftWithPurchaseTransactionReportCriteria,
  GroupOrderUnpickedItemReportCriteria,
  LoadingGroupByWarehouseCriteria,
  PreOrderCreditRemainingReportCriteria,
  PromotionCompensateReportExportCriteria,
  ReceiptCouponTransactionReportCriteria,
  ReceiveToteReportCriteria,
  ReduceToClearSummaryReportCriteria,
  ReduceToClearTransactionReportCriteria,
  ReturnToWarehouseGRReportCriteria,
  ReturnToWarehouseOrderReportCriteria,
  ReturnToteReportCriteria,
  SalePerformanceReportCriteria,
  StockCountAssignmentSummaryReportCriteria,
  StockCountAssignmentTransactionReportCriteria,
  StockCountByQISummaryDailyReportCriteria,
  StockCountByQISummaryReportCriteria,
  StockCountByQITransactionReportCriteria,
  StockCountByStaffTransactionReportCriteria,
  StockRefillSummaryCriteria,
  StoreApprovalBypassReportCriteria,
  StoreAvailableAdjustmentRequestReportCriteria,
  StoreToteFineReportCriteria,
  StoreToteReportCriteria,
  ToteAdjustmentReportCriteria
} from '@shared/models/report.model';
import { dateTimeToDateOnlyString } from '@shared/utils/date-util';

import {
  ExportStoreAssortmentByProductCriteria,
  ExportStoreAssortmentByStoreCriteria
} from '../../../../pages/store-assortment/models/store-assortment-request-store.model';
import { dynamicReportAction } from '../stores/dynamic-reports.actions';

export class DynamicReportLogic {
  private reportActions: Map<string, any>;

  constructor() {
    this.reportActions = new Map<string, any>();

    this.initAction();
  }

  private initAction() {
    this.reportActions.set(ActionReportEnum.RETURN_TO_WAREHOUSE_ORDER, {
      action: (payload: any) => {
        return this.returnToWarehouseOrderDoCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.RETURN_TO_WAREHOUSE_GR, {
      action: (payload: any) => {
        return this.returnToWarehouseGRDoCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.RETURN_TO_WAREHOUSE_CHARGE, {
      action: (payload: any) => {
        return this.returnToWarehouseChargeDoCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.TOTE_ADJUSTMENT, {
      action: (payload: any) => {
        return dynamicReportAction.toteAdjustment({
          payload: this.mappingToCriteria(ToteAdjustmentReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.PROMOTION_COMPENSATE, {
      action: (payload: any) => {
        return dynamicReportAction.promotionCompensate({
          payload: this.mappingToCriteria(PromotionCompensateReportExportCriteria, payload, ['classes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.AWAITING_ALLOCATION_FOR_GROUP_ORDER, {
      action: (payload: any) => {
        return this.awaitingAllocationForGroupOrderCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.PRE_ORDER_CREDIT_REMAINING, {
      action: (payload: any) => {
        return this.preOrderCreditRemainingCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.GROUP_ORDER_UNPICKED_ITEM, {
      action: (payload: any) => {
        return dynamicReportAction.groupOrderUnpickedItem({
          payload: this.mappingToCriteria(GroupOrderUnpickedItemReportCriteria, payload, [
            'storeCode',
            'warehouseCode',
            'orderType'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.COMPANY_ASSORTMENT, {
      action: (payload: any) => {
        return dynamicReportAction.companyAssortment({
          payload: this.mappingToCriteria(ExportAssortmentSearchCriteria, payload, [
            'productType',
            'orderingMethods',
            'deliveryMethods',
            'productStatuses'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.ASSORTMENT_CONFIDENTIAL, {
      action: (payload: any) => {
        return dynamicReportAction.companyAssortmentConfidential({
          payload: this.mappingToCriteria(ExportAssortmentSearchCriteria, payload, [
            'productType',
            'orderingMethods',
            'deliveryMethods',
            'productStatuses'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.DC_ASSORTMENT, {
      action: (payload: any) => {
        payload.warehouseCode = [payload.warehouseCode];
        return dynamicReportAction.dcAssortment({
          payload: this.mappingToCriteria(DcAssortmentExportCriteria, payload, ['warehouseCode'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STORE_ASSORTMENT, {
      action: (payload: any) => {
        return dynamicReportAction.storeAssortment({
          payload: this.mappingToCriteria(ExportStoreAssortmentByStoreCriteria, payload, ['storeNo'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.PRODUCT_BY_LOCATION, {
      action: (payload: any) => {
        return this.productByLocationCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.STORE_APPROVAL_BYPASS, {
      action: (payload: any) => {
        return dynamicReportAction.storeApprovalBypass({
          payload: this.mappingToCriteria(StoreApprovalBypassReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CROSS_DOCK_INVOICE, {
      action: (payload: any) => {
        return dynamicReportAction.crossDockInvoice({
          payload: this.mappingToCriteria(CrossDockInvoiceReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STORE_TOTE, {
      action: (payload: any) => {
        payload.storeCodes = payload.storeCodes?.length ? payload.storeCodes : null;
        payload.toteId = payload.toteId ?? null;
        return dynamicReportAction.storeTote({
          payload: this.mappingToCriteria(StoreToteReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STORE_TOTE_FINE, {
      action: (payload: any) => {
        return dynamicReportAction.storeToteFine({
          payload: this.mappingToCriteria(StoreToteFineReportCriteria, payload, ['fineType', 'location'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.DESTROY_TRANSACTION_REPORT, {
      action: (payload: any) => {
        return this.destroyTransactionExportReportCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.REDUCE_TO_CLEAR_TRANSACTION, {
      action: (payload: any) => {
        return this.destroyTransactionExportReportCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.CJX_SALES_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.cjxSalesTransaction({
          payload: this.mappingToCriteria(CJXSalesTransactionReportCriteria, payload, ['storeCodes', 'salesType'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CJX_VOUCHER_REPORT, {
      action: (payload: any) => {
        return this.cjxVoucherTransactionExportReportCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.REDUCE_TO_CLEAR_SUMMARY, {
      action: (payload: any) => {
        return this.reduceToClearSummaryExportReportCriteria(payload);
      }
    });

    this.reportActions.set(ActionReportEnum.CASH_SETTLEMENT_TRANSACTION_BEFORE_GO_LIVE, {
      action: (payload: any) => {
        return dynamicReportAction.cashSettlementTransactionBeforeGoLive({
          payload: this.mappingToCriteria(CashSettlementTransactionReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CASH_SETTLEMENT_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.cashSettlementTransaction({
          payload: this.mappingToCriteria(CashSettlementTransactionReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CASH_COUNTING, {
      action: (payload: any) => {
        return dynamicReportAction.cashCounting({
          payload: this.mappingToCriteria(CashCountingReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.RECEIPT_COUPON, {
      action: (payload: any) => {
        return dynamicReportAction.receiptCoupon({
          payload: this.mappingToCriteria(ReceiptCouponTransactionReportCriteria, payload, [
            'status',
            'receiptCouponType'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_BY_QI_SUMMARY, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountByQISummary({
          payload: this.mappingToCriteria(StockCountByQISummaryReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_BY_QI_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountByQITransaction({
          payload: this.mappingToCriteria(StockCountByQITransactionReportCriteria, payload, [
            'storeCodes',
            'compareStockResults'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STORE_AVAILABLE_ADJUSTMENT_REQUEST, {
      action: (payload: any) => {
        return dynamicReportAction.storeAvailableAdjustmentRequest({
          payload: this.mappingToCriteria(StoreAvailableAdjustmentRequestReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_ASSIGNMENT_SUMMARY, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountAssignmentSummary({
          payload: this.mappingToCriteria(StockCountAssignmentSummaryReportCriteria, payload, [
            'storeCodes',
            'stockCountStatus'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_ASSIGNMENT_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountAssignmentTransaction({
          payload: this.mappingToCriteria(StockCountAssignmentTransactionReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_BY_STAFF_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountByStaffTransaction({
          payload: this.mappingToCriteria(StockCountByStaffTransactionReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_COUNT_BY_QI_DAILY_SUMMARY, {
      action: (payload: any) => {
        return dynamicReportAction.stockCountByQIDailySummary({
          payload: this.mappingToCriteria(StockCountByQISummaryDailyReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.SALES_PERFORMANCE, {
      action: (payload: any) => {
        return dynamicReportAction.salePerformance({
          payload: this.mappingToCriteria(SalePerformanceReportCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.COUNT_ITEM_IN_TOTE, {
      action: (payload: any) => {
        return dynamicReportAction.countItemInTote({
          payload: this.mappingToCriteria(CountItemInToteReportCriteria, payload, ['status', 'storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CJX_MEMBER_REWARD_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.cjxMemberRewardTransactions({
          payload: this.mappingToCriteria(CJXMemberRewardTransactionCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.GIFT_WITH_PURCHASE, {
      action: (payload: any) => {
        return dynamicReportAction.giftWithPurchase({
          payload: this.mappingToCriteria(GiftWithPurchaseReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.GIFT_WITH_PURCHASE_TRANSACTION, {
      action: (payload: any) => {
        return dynamicReportAction.giftWithPurchaseTransaction({
          payload: this.mappingToCriteria(GiftWithPurchaseTransactionReportCriteria, payload, [
            'storeCodes',
            'supplierCode'
          ])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.STOCK_REFILL_SUMMARY, {
      action: (payload: any) => {
        return dynamicReportAction.stockRefillSummary({
          payload: this.mappingToCriteria(StockRefillSummaryCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.LOADING_GROUP_BY_WAREHOUSE, {
      action: (payload: any) => {
        return dynamicReportAction.loadingGroupByWarehouse({
          payload: this.mappingToCriteria(LoadingGroupByWarehouseCriteria, payload, ['warehouseCode', 'productTypes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.DISPATCH_TOTE, {
      action: (payload: any) => {
        return dynamicReportAction.dispatchTote({
          payload: this.mappingToCriteria(DispatchToteReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.RECEIVE_TOTE, {
      action: (payload: any) => {
        return dynamicReportAction.receiveTote({
          payload: this.mappingToCriteria(ReceiveToteReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.RETURN_TOTE, {
      action: (payload: any) => {
        return dynamicReportAction.returnTote({
          payload: this.mappingToCriteria(ReturnToteReportCriteria, payload)
        });
      }
    });

    this.reportActions.set(ActionReportEnum.CHECK_PRODUCT_TAG, {
      action: (payload: any) => {
        return dynamicReportAction.checkProductTag({
          payload: this.mappingToCriteria(CheckProductTagCriteria, payload, ['storeCodes'])
        });
      }
    });

    this.reportActions.set(ActionReportEnum.COLLECT_EXPIRED_PROMOTION_TAG, {
      action: (payload: any) => {
        return dynamicReportAction.collectExpiredPromotionTag({
          payload: this.mappingToCriteria(CollectExpiredPromotionTagCriteria, payload, ['storeCodes'])
        });
      }
    });
  }

  public transformPayloadAndCriteria(reportType: ActionReportEnum, payload: any) {
    if (this.reportActions.has(reportType)) {
      return this.reportActions.get(reportType).action(payload);
    }

    return null;
  }

  private exportReportErrorMessage(message: string) {
    return dynamicReportAction.exportReportError({
      isSuccess: false,
      error: {
        error: {
          message
        }
      }
    });
  }

  private returnToWarehouseGRDoCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.shipFrom as any as string[], 100, 'locations');
    if (validateLimitStore) {
      return validateLimitStore;
    }

    const criteriaObj = {
      createdDateFrom: payload.createdDateFrom ? dateTimeToDateOnlyString(new Date(payload.createdDateFrom)) : null,
      createdDateTo: payload.createdDateTo ? dateTimeToDateOnlyString(new Date(payload.createdDateTo)) : null,
      shipFromCodeName: payload.shipFrom ? (payload.shipFrom as any as string[]).join(',') : null,
      shipToCodeName: payload.shipTo ? (payload.shipTo as any as string[]).join(',') : null,
      status: payload.status ? (payload.status as any as string[]).join(',') : null,
      returnType: payload.returnType ? (payload.returnType as any as string[]).join(',') : null,
      fileType: payload.fileType
    };

    return dynamicReportAction.returnToWarehouseGR({ payload: new ReturnToWarehouseGRReportCriteria(criteriaObj) });
  }

  private returnToWarehouseOrderDoCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.shipFrom as any as string[], 100, 'locations');
    if (validateLimitStore) {
      return validateLimitStore;
    }

    const criteriaObj: ReturnToWarehouseOrderReportCriteria = {
      createdDateFrom: payload.createdDateFrom ? dateTimeToDateOnlyString(new Date(payload.createdDateFrom)) : null,
      createdDateTo: payload.createdDateTo ? dateTimeToDateOnlyString(new Date(payload.createdDateTo)) : null,
      shipFromCodeName: payload.shipFrom ? (payload.shipFrom as any as string[]).join(',') : null,
      shipToCodeName: payload.shipTo ? (payload.shipTo as any as string[]).join(',') : null,
      status: payload.status ? (payload.status as any as string[]).join(',') : null,
      returnType: payload.returnType ? (payload.returnType as any as string[]).join(',') : null,
      fileType: payload.fileType
    };

    return dynamicReportAction.returnToWarehouseOrder({
      payload: criteriaObj
    });
  }

  private returnToWarehouseChargeDoCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.shipFrom as any as string[], 100, 'locations');
    if (validateLimitStore) {
      return validateLimitStore;
    }

    const criteriaObj = {
      createdDateFrom: payload.createdDateFrom ? dateTimeToDateOnlyString(new Date(payload.createdDateFrom)) : null,
      createdDateTo: payload.createdDateTo ? dateTimeToDateOnlyString(new Date(payload.createdDateTo)) : null,
      shipFromCodeName: payload.shipFrom ? (payload.shipFrom as any as string[]).join(',') : null,
      shipToCodeName: payload.shipTo ? (payload.shipTo as any as string[]).join(',') : null,
      returnType: payload.returnType ? (payload.returnType as any as string[]).join(',') : null,
      fileType: payload.fileType
    };

    return dynamicReportAction.returnToWarehouseCharge({ payload: criteriaObj });
  }

  awaitingAllocationForGroupOrderCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCode as any as string[], 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    return dynamicReportAction.awaitingAllocationForGroupOrder({
      payload: this.mappingToCriteria(AwaitingAllocationForGroupOrderReportCriteria, payload, [
        'storeCode',
        'orderType',
        'warehouseCode'
      ])
    });
  }

  private preOrderCreditRemainingCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCodes, 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    const reportCriteria = this.mappingToCriteria(PreOrderCreditRemainingReportCriteria, payload, ['storeCodes']);
    return dynamicReportAction.preOrderCreditRemaining({ payload: reportCriteria });
  }

  private productByLocationCriteria(payload) {
    const reportCriteria: ExportStoreAssortmentByProductCriteria = {
      articleNo: payload.barcode.articleNo,
      barcode: payload.barcode.barcode,
      fileType: payload.fileType
    };
    return dynamicReportAction.productByLocation({ payload: reportCriteria });
  }

  private destroyTransactionExportReportCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCodes, 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    const reportCriteria = this.mappingToCriteria(DestroyTransactionExportReportCriteria, payload, [
      'storeCodes',
      'status'
    ]);
    return dynamicReportAction.exportReportDestroyTransaction({ payload: reportCriteria });
  }

  private reduceToClearTransactionExportReportCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCodes, 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    const reportCriteria = this.mappingToCriteria(ReduceToClearTransactionReportCriteria, payload, ['storeCodes']);
    return dynamicReportAction.exportReduceToClearTransaction({ payload: reportCriteria });
  }

  private cjxVoucherTransactionExportReportCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCodes, 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    const reportCriteria = this.mappingToCriteria(CJXVoucherExportCriteria, payload, ['storeCodes']);
    return dynamicReportAction.cjxVoucher({ payload: reportCriteria });
  }

  private reduceToClearSummaryExportReportCriteria(payload) {
    const validateLimitStore = this.validateLimitListExceeded(payload?.storeCodes, 100, 'stores');
    if (validateLimitStore) {
      return validateLimitStore;
    }
    const reportCriteria = this.mappingToCriteria(ReduceToClearSummaryReportCriteria, payload, [
      'storeCodes',
      'status'
    ]);
    return dynamicReportAction.exportReportReduceToClearSummary({ payload: reportCriteria });
  }

  private mappingToCriteria<T>(type: { new (): T }, value: any, direct: string[] = null): T {
    let criteria = new type();
    for (let name in value) {
      if (direct && direct.includes(name)) {
        criteria[name] = value[name];
      } else if (value[name] && name.toLocaleLowerCase().indexOf('datefrom') >= 0) {
        criteria[name] = dateTimeToDateOnlyString(new Date(value[name]));
      } else if (value[name] && name.toLocaleLowerCase().indexOf('dateto') >= 0) {
        criteria[name] = dateTimeToDateOnlyString(new Date(value[name]));
      } else if (value[name] instanceof Array) {
        criteria[name] = value[name].length > 0 ? value[name].toString() : null;
      } else {
        criteria[name] = value[name];
      }
    }
    return criteria;
  }

  private validateLimitListExceeded<T>(items: T[], limit: number, limitType: string) {
    if (items && items.length > limit) {
      return this.exportReportErrorMessage(`Export limit exceeded (up to ${limit} ${limitType}).`);
    }

    return null;
  }
}
